import React from "react";

/* ===== Enhanced Tech Badge ===== */
const TechBadge = ({ children, index }) => {
  return (
    <span
      className="
        group relative overflow-hidden
        inline-flex items-center gap-3
        rounded-2xl px-7 py-3
        text-base font-semibold
        text-foreground
        backdrop-blur-xl
        border border-brand-green/20
        bg-gradient-to-br from-white/80 to-white/60
        shadow-soft
        transition-all duration-300
        hover:-translate-y-1 hover:shadow-card-hover hover:border-brand-green/40
      "
    >
      {/* glow ring */}
      <span className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-2xl bg-gradient-to-r from-brand-green/20 to-brand-blue/20 blur-xl" />

      {/* animated dot */}
      <span
        className="
          h-2.5 w-2.5 rounded-full
          bg-gradient-to-r from-brand-green to-brand-blue
          animate-pulse
        "
        style={{ animationDelay: `${index * 0.15}s` }}
      />

      {/* text */}
      <span className="relative z-10 tracking-wide">
        {children}
      </span>

      {/* shine sweep */}
      <span className="pointer-events-none absolute inset-0 -translate-x-full group-hover:translate-x-[200%] transition-transform duration-700 bg-gradient-to-r from-transparent via-white/60 to-transparent skew-x-[-20deg]" />
    </span>
  );
};

/* ===== Enhanced Tech Carousel ===== */
const TechCarousel = ({ technologies }) => {
  const tripled = [...technologies, ...technologies, ...technologies];

  return (
    <div className="relative overflow-hidden py-12">

      {/* background glow strip */}
      <div className="absolute inset-0 -z-10 bg-gradient-to-r from-brand-green/5 via-transparent to-brand-blue/5 blur-2xl" />
      <div
        className="
          flex w-max gap-6
          animate-scroll-tech
          hover:[animation-play-state:paused]
        "
      >
        {tripled.map((tech, i) => (
          <TechBadge key={`${tech}-${i}`} index={i}>
            {tech}
          </TechBadge>
        ))}
      </div>
    </div>
  );
};

export default TechCarousel;
